<template>
  <div class="main-content">
    <div class="card">
      <h5 class="card-header d-flex justify-content-between align-items-center">
        <div class="flex-grow-1">
          <span v-if="id">Редактировать</span><span v-else>Добавить</span> сегмент
        </div>
        <vue-ladda
          button-class="btn btn-sm btn-secondary"
          data-style="zoom-in"
          @click="goBack()"
          :loading="loading === 'back'"
        ><i class="icon-fa icon-fa-arrow-circle-o-left"></i>Назад</vue-ladda>
      </h5>
      <div class="card-body">
        <div class="form-group">
          <label>Препарат:</label>
          <drugSearch v-if="!id" ref="drugSearch"/>
          <h5 v-else>{{ drug.title }}</h5>
        </div>
        <div class="d-flex">
          <div>
            <div class="form-group">
              <label><span style="color:#209002;">ДОБАВИТЬ</span> клиентов из заказов, в период:</label>
              <div class="input-group align-items-center">
                <datetime
                  id="include_from"
                  input-class="form-control"
                  value-zone="UTC"
                  zone="UTC"
                  type="date"
                  format="dd.MM.yyyy"
                  :auto="true"
                  v-model="include_from"></datetime>
                <span>&nbsp;—&nbsp;</span>
                <datetime
                  id="include_to"
                  input-class="form-control"
                  type="date"
                  format="dd.MM.yyyy"
                  :auto="true"
                  v-model="include_to"></datetime>
              </div>
            </div>
            <div class="form-group">
              <label><span style="color:#b10606;">ИСКЛЮЧИТЬ</span> клиентов из заказов, в период:</label>
              <div class="input-group align-items-center">
                <datetime
                  id="exclude_from"
                  input-class="form-control"
                  type="date"
                  format="dd.MM.yyyy"
                  :auto="true"
                  v-model="exclude_from"></datetime>
                <span>&nbsp;—&nbsp;</span>
                <datetime
                  id="exclude_to"
                  input-class="form-control"
                  type="date"
                  format="dd.MM.yyyy"
                  :auto="true"
                  v-model="exclude_to"></datetime>
              </div>
            </div>
          </div>
          <div class="form-group ml-5">
            <label>Текст sms:</label>
            <textarea class="form-control" style="width:400px; max-width: 100%; height:120px;"
                      v-model="template" maxlength="200"></textarea>
            <div class="text-right">
              <small v-if="template.length > 0">{{ template.length }} симв.</small>
            </div>
          </div>
        </div>
        <vue-ladda
          button-class="btn btn-success"
          data-style="zoom-in"
          @click="sendData()"
          :loading="loading === 'save'"
        ><i class="icon-fa icon-fa-save"></i>Сохранить</vue-ladda>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "@/api";
  import VueLadda from "vue-ladda/src/vue-ladda.vue";
  import drugSearch from "@/components/drugs/drugSearch2";
  import {Datetime} from 'vue-datetime';
  import moment from "moment";

  export default {
    components: {
      VueLadda,
      drugSearch,
      Datetime,
    },
    data () {
      return {
        id: null,
        loading: false,
        search: '',
        include_from: null,
        include_to: null,
        exclude_from: null,
        exclude_to: null,
        drug: '',
        template: '',
      }
    },
    methods: {
      goBack() {
        this.loading = 'back';
        this.mixinGoToRouter('segmentsSMS');
      },
      async parseTemplate(drugId) {
        let {data} = await api.index('/sms/segment/template?drugId=' + drugId);
        if (data.template) {
          this.template = data.template;
        }
      },
      async sendData() {
        this.loading = 'save';

        let drugId = null;
        if (this.id) {
          drugId = this.drug.id;
        } else {
          let drug = this.$refs.drugSearch ? this.$refs.drugSearch.drug : '';
          drugId = drug && drug.id ? drug.id : drugId;
        }

        let {data} = await api.post('/sms/segment/store', {
          segment_id: parseInt(this.id),
          drug_id: drugId,
          include_from: this.include_from,
          include_to: this.include_to,
          exclude_from: this.exclude_from,
          exclude_to: this.exclude_to,
          template: this.template,
        });

        if (data.success) {
          this.$router.push({name: 'segmentsSMS'});
        } else {
          toastr['error'](data.error || 'Ошибка!');
          this.loading = false;
        }
      }
    },
    created(){
      this.id = this.$route.params.id;
    },
    async mounted() {
      this.$watch(
        () => {
          return this.$refs.drugSearch ? this.$refs.drugSearch.drug : '';
        },
        (val) => {
          if (val) {
            this.parseTemplate(val.id);
          }
        }
      )

      if (this.id) {
        let {data} = await api.index('/sms/segment/show?segment_id=' + this.id);
        console.log(data);
        this.drug = data.drug;

        if (data.include_from) {
          this.include_from = moment(data.include_from).toISOString();
        }
        if (data.include_to) {
          this.include_to = moment(data.include_to).toISOString();
        }
        if (data.exclude_from) {
          this.exclude_from = moment(data.exclude_from).toISOString();
        }
        if (data.exclude_to) {
          this.exclude_to = moment(data.exclude_to).toISOString();
        }

        this.template = data.template;
      }
    },
  };
</script>
